// Navigation scripts
const navmanager = {
    stickyNavScroll: function () {
        const body = document.body;

        var scrollUp = 'scrollup';
        var scrollDown = 'scrolldown';
        var lastScrollTop = 0;

        document.addEventListener('scroll', function () {
            window.requestAnimationFrame(checkScrollDirection);
        });

        function isSafariBrowser() {
            var userAgent = navigator.userAgent;
            return userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1 && userAgent.indexOf("Firefox") === -1;
          }
          
          // if (isSafariBrowser()) {
          //   console.log("Current browser is Safari");
          // } else {
          //   console.log("Current browser is not Safari");
          // }

        function checkScrollDirection(event){
            if (checkScrollDirectionIsUp(event)) {
                if (body.classList.contains('safari')) {
                    // Remove the "safari" class
                    body.classList.remove(scrollUp);
                  } else if (checkScrollDirectionIsUp(event)) {
                    body.classList.add(scrollUp);
                    body.classList.remove(scrollDown);
                } else {
                    body.classList.remove(scrollUp);
                    body.classList.add(scrollDown);
                    // Check if body has the "scroll-down" class
                }
            }    
        }
    

        function checkScrollDirectionIsUp(event)
        {
            var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollTop > lastScrollTop) {
                lastScrollTop = currentScrollTop;
                return false;
            }

            lastScrollTop = currentScrollTop;

            return true;
        }

        //Knowledge Base Anchors
        const kbanchors = document.querySelectorAll('.kb-article__anchor-link');
        kbanchors.forEach(el => el.addEventListener('click', event => {
            body.classList.add(scrollDown);
            body.classList.remove(scrollUp);
        }));

        //Scroll up
        const scrollups = document.querySelectorAll('.scrollup');
        scrollups.forEach(el => el.addEventListener('click', event => {
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);

            document.querySelector('.switch-hp-logo').style.display = 'none;'
            //console.log('up');
        }));


    }, observers: function () {
        const headerEl = document.querySelector('.desktop-nav')
        const headermobEL = document.querySelector('.mobile-header')
        const sentinalEl = document.querySelector('.sentinal')

        const handler = (entries) => {
            if (!entries[0].isIntersecting) {
                setTimeout(() => {  
                    headerEl.classList.add('scrolled')
                    headermobEL.classList.add('scrolled')
                 }, 150);
            } else {
                setTimeout(() => {  
                    headerEl.classList.remove('scrolled')
                    headermobEL.classList.remove('scrolled')
                }, 150);
            }
        }

        const observer = new window.IntersectionObserver(handler)

        if (sentinalEl != undefined) {
            observer.observe(sentinalEl)
        }
    }, searchtoggle: function () {

        var searchform = document.getElementById('search-modal');
        var searchinput = document.getElementById('s');
        const divs = document.querySelectorAll('.open-search');
        const closedivs = document.querySelectorAll('.close-search');

        divs.forEach(el => el.addEventListener('click', event => {
            event.preventDefault();
            event.target.classList.toggle('open');
            searchform.classList.toggle('open');
            searchinput.focus();
        }));
        closedivs.forEach(el => el.addEventListener('click', event => {
            event.preventDefault();
            searchform.classList.remove('open');
        }));
    }
}

export default navmanager;